import { useWhiteLabelContext } from 'components/white-label/context';
import { Organization } from 'lib/types/company';
import _ from 'lodash';
import type { ReactNode } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

export const IntercomContext = createContext({
  isVisible: false,
  setIsVisible: _.noop,
  reference: undefined,
  setReference: _.noop,
});

export const useIntercomContext = () => useContext(IntercomContext);

interface IIntercomProps {
  name: string;
  email: string;
  children?: ReactNode;
}

export const Intercom = ({ name, email, children }: IIntercomProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [reference, setReference] = useState<HTMLDivElement>();
  const { organization } = useWhiteLabelContext();

  useEffect(() => {
    if ((window as any).Intercom && organization !== Organization.LIFE_LABS) {
      (window as any).Intercom('boot', {
        app_id: 'z232p01v',
        name: name,
        email: email,
        action_color: '#2872dc',
        background_color: '#2872dc',
      });
      setIsVisible(true);

      return function cleanup() {
        (window as any).Intercom('shutdown');
      };
    }
  }, []);

  useEffect(() => {
    if ((window as any).Intercom && organization !== Organization.LIFE_LABS) {
      (window as any).Intercom('update', {
        hide_default_launcher: !isVisible,
      });
    }
  }, [isVisible]);

  return (
    <IntercomContext.Provider
      value={{ isVisible, setIsVisible, reference, setReference }}
    >
      {children}
    </IntercomContext.Provider>
  );
};
